let paragraphs: any = {
  speakerList: [],
  commonUseSpeakersData: [],
  numAva: 0,
  filterOption: {},
};

const setParagraphsData = (key, val) => {
  paragraphs[key] = val;
};

const getParagraphsData = (key) => {
  return paragraphs[key];
};

const destroyParagraphsData = () => {
  paragraphs = {};
};

export { setParagraphsData, getParagraphsData, destroyParagraphsData };
